import React from "react";
import classes from "./WordGameInfoModal.module.css";
import { useTranslation } from "react-i18next";

const WordGameInfoModal = ({ closeModal }) => {

  const {t}=useTranslation();

  return (
    <div className={classes.modal_container}>
      <div className={classes.modal_subcontainer}>
        <h2 className={classes.text_main}>{t("143")}</h2>
        <p className={classes.text_secondary}>{t("144")}</p>
        <ul>
          <li className={classes.text_secondary_2}>
            {t("145")}
          </li>
          <li className={classes.text_secondary_2}>
            {t("146")}
          </li>
        </ul>
        <h3 className={classes.text_main_2}>{t("147")}</h3>
        <ul>
          <li style={{ listStyle: "none" }}>
            <div>
              <div className={classes.word_container}>
                <div
                  className={classes.letter}
                  style={{ backgroundColor: "#339AF0" }}
                >
                  T
                </div>
                <div
                  className={classes.letter}
                  style={{ backgroundColor: "#339AF0" }}
                >
                  R
                </div>
                <div className={classes.letter}>I</div>
                <div
                  className={classes.letter}
                  style={{ backgroundColor: "#339AF0" }}
                >
                  E
                </div>
                <div className={classes.letter}>D</div>
              </div>
              <strong style={{ color: "black" }}>T R E </strong>
              <span className={classes.span_word}>
                {t("148")}
              </span>
            </div>
          </li>
          <li style={{ listStyle: "none" }}>
            <div className={classes.word_container}>
              <div
                className={classes.letter}
                style={{ backgroundColor: "#339AF0" }}
              >
                R
              </div>
              <div
                className={classes.letter}
                style={{ backgroundColor: "#339AF0" }}
              >
                E
              </div>
              <div
                className={classes.letter}
                style={{ backgroundColor: "#339AF0" }}
              >
                A
              </div>
              <div className={classes.letter}>D</div>
              <div className={classes.letter}>Y</div>
            </div>
            <strong style={{ color: "black" }}>R E A </strong>{" "}
            <span className={classes.span_word}>
              {t("149")}
            </span>
          </li>
          <li style={{ listStyle: "none" }}>
            <div className={classes.word_container}>
              <div
                className={classes.letter}
                style={{ backgroundColor: "#339AF0" }}
              >
                T
              </div>
              <div
                className={classes.letter}
                style={{ backgroundColor: "#339AF0" }}
              >
                R
              </div>
              <div
                className={classes.letter}
                style={{ backgroundColor: "#339AF0" }}
              >
                E
              </div>
              <div
                className={classes.letter}
                style={{ backgroundColor: "#339AF0" }}
              >
                A
              </div>
              <div
                className={classes.letter}
                style={{ backgroundColor: "#339AF0" }}
              >
                T
              </div>
            </div>
            <strong style={{ color: "black" }}>{t("150")} </strong>
            <span className={classes.span_word}>{t("151")}</span>
          </li>
        </ul>
        <div className={classes.btn_container}>
          <button className={classes.close_button} onClick={closeModal}>
            {t("152")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WordGameInfoModal;
